import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/ui/button';
import { Modal } from '@buildoutinc/blueprint-react/ui/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { connect } from 'react-redux';
import { get } from 'helpers/api';
import { showSnackbar } from 'components/ui/snackbar/helper';

const MODAL_STATES = {
  DEFAULT: 'default',
  SENDING: 'sending',
  SENT: 'sent'
};

function EmailCaModal({ caDownloadPath, projectName, show, onClose }) {
  const [modalState, setModalState] = useState(MODAL_STATES.DEFAULT);

  async function sendEmailCa() {
    setModalState(MODAL_STATES.SENDING);
    await get(caDownloadPath);
    setModalState(MODAL_STATES.SENT);
    showSnackbar({ text: 'Preparing Documents for Email', variant: 'success' });
    onClose();
  }

  const sendButtonDisabled = modalState === MODAL_STATES.SENDING || modalState === MODAL_STATES.SENT;

  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title className="d-flex gap-2 align-items-center">
            <FontAwesomeIcon className="text-primary" icon={faEnvelope} />
            Email CA Activity
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div>We will be sending you an email with a link to the lead's activity for
              <span className="fw-bold"> {projectName}.</span>
            </div>
            <div className="fw-bold">This link only will be valid for 24 hours</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button label="Cancel" type="button" variant="ghost" onClick={onClose}/>
          <Button disabled={sendButtonDisabled} type="button" onClick={sendEmailCa}>
            {modalState === MODAL_STATES.DEFAULT && 'Send'}
            {modalState === MODAL_STATES.SENDING && 'Sending...'}
            {modalState === MODAL_STATES.SENT && 'Sent'}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}

EmailCaModal.propTypes = {
  caDownloadPath: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

const mapStateToProps = props => ({ projectName: props.project.displayName });

export default connect(mapStateToProps)(EmailCaModal);
